module.exports = __webpack_public_path__ + "Banner_publications.jpg?9c537153a95a8481386ee673b4b2f8a3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/publications/Banner_publications.jpg
// module id = 304
// module chunks = 0